<template>
  <div>
    <div class="address-list">
      <div class="address-list__header">{{ localize.KZ_COMPONENTS_PERSONAL_ADDRESS_TITLE }}</div>
      <div class="address-list__list">
        <label class="radio-item address-list__item" v-for="key in Object.keys(itemList)">
          <input type="radio" ref="personal-address-input" name="personalAddress" class="personal-address-list__input"
                 :value="key">
          {{ Object.values(itemList[key]).join(', ') }}
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    itemList: Object,
    selectedItem: String,
  },

  computed: {
    localize() {
      return BX.Vue.getFilteredPhrases('KZ_COMPONENTS_');
    },
    selected() {
      return this.selectedItem;
    }
  },

  mounted() {
    let radioAddress = $(this.$refs['personal-address-input']);

    radioAddress.on('change', (event) => {
      document.getElementsByName('personalAddress').forEach((item) => {
        item.value == event.target.value ? item.parentElement.classList.add('active') : item.parentElement.classList.remove('active');
      });

      this.$emit('change', event.target.value);
    });
  },
};
</script>
<style>
  .address-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
    justify-content: space-between;
  }

  .address-list__header {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #D2C5BE;
    margin-top: 19px;
  }

  .address-list__list {
    width: 100%;
    max-width: 604px;
  }

  .address-list .address-list__item {
    height: 60px;
    background: #FBFBFB;
    position: relative;
    padding-top: 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #9E8066;
  }

  .address-list .address-list__item:before {
    top: 17px;
  }

  .address-list__item:not(:last-child) {
    margin-bottom: 1px;
  }
</style>